import { registerApplication, start } from 'single-spa';

const domElementGetter =
  (containerId = '') =>
  ({ name }) => {
    const container = document.getElementById(containerId);
    container.dataset.appName = name;
    return container;
  };

registerApplication({
  name: '@sureapp/auto',
  app: () => System.import('@sureapp/auto'),
  activeWhen: (location) => {
    return !location.pathname.includes('/homeowners');
  },
  customProps: () => ({
    domElementGetter: domElementGetter('root'),
  }),
});

registerApplication({
  name: '@sureapp/homeowners',
  app: () => System.import('@sureapp/homeowners'),
  activeWhen: (location) => {
    return location.pathname.includes('/homeowners');
  },
  customProps: () => ({
    domElementGetter: domElementGetter('root'),
  }),
});

start({
  urlRerouteOnly: false,
});
